import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Spinner from '../../../Component/Spinner/Spinner';
import { AuthContext } from '../../../Context/UseContext';
import useScrollToTop from '../../../hooks/useScrollToTop';
import useTitle from '../../../hooks/useTitle';
import {
    HiTrash,
} from "react-icons/hi";
import toast from "react-hot-toast";
import { useDbUser } from '../../../hooks/useUser';
import ErrorMessage from '../../Shared/ErrorMessage/ErrorMessage';
import BookingModal from '../../../Component/BookingModal/BookingModal';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';

const MyWishlist = () => {
    useScrollToTop();
    useTitle("My Wishlist");
    const [errorMessages, setErrorMessages] = useState("");
    const { user, loading } = useContext(AuthContext);
    const [booking, setBooking] = useState(null);
    const [dbUser, isDbUserLoading] = useDbUser(user.email);
    const [deletingProduct, setDeletingProduct] = useState(null);

    const closeModal = () => {
        setDeletingProduct(null);
    };

    const {
        data: myWishlist = [],
        refetch,
        isLoading,
    } = useQuery({
        queryKey: ["myWishlist"],
        queryFn: async () => {
            if (dbUser) {
                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/wishlist?email=${dbUser?.email}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );
                const data = await res.json();

                if (data.success) {
                    setErrorMessages("");
                    return data.data;
                } else {
                    setErrorMessages(data.error);
                    return [];
                }
            } else {
                return [];
            }
        },
    });

    useEffect(() => {
        refetch();
    }, [dbUser, refetch]);

    if (loading || isDbUserLoading || isLoading) return <Spinner />;
    if (!dbUser)
        return <ErrorMessage error="Please login to view your wishlist" />;
    if (errorMessages) return <ErrorMessage error={errorMessages} />;

    const handleDeleteWishlist = (order) => {
        fetch(`${process.env.REACT_APP_API_URL}/wishlist/${order._id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    toast.success(data.message);
                    refetch();
                } else {
                    toast.error(data.error);
                    setErrorMessages(data.error);
                }
            })
            .catch((err) => {
                toast.error(err.message);
                setErrorMessages(err.message);
            });
    };

    return (
        <>
            <div className="px-5">
                <h4 className="mb-4 text-2xl font-semibold text-gray-600 dark:text-gray-300">
                    My Wishlist ({myWishlist?.length})
                </h4>
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap ">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
                                    <th className="px-4 py-3">Product</th>
                                    <th className="px-4 py-3">Price</th>
                                    <th className="px-4 py-3">Location</th>
                                    <th className="px-4 py-3">Seller Phone</th>
                                    <th className="px-4 py-3">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-900">
                                {myWishlist?.map((order) => (
                                    <tr
                                        className="text-gray-700 dark:text-gray-400"
                                        key={order?._id}
                                    >
                                        <td className="px-4 py-3">
                                            <div className="flex items-center text-sm">
                                                {/* <!-- Avatar with inset shadow --> */}
                                                <div className="relative hidden w-8 h-8 mr-3 rounded-full md:block">
                                                    <img
                                                        className="object-cover w-full h-full rounded-full"
                                                        src={order?.img}
                                                        alt={order?.title}
                                                        loading="lazy"
                                                    />
                                                    <div
                                                        className="absolute inset-0 rounded-full shadow-inner"
                                                        aria-hidden="true"
                                                    ></div>
                                                </div>
                                                <div>
                                                    <p className="font-semibold">{order?.title}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3 text-sm">
                                            ৳ {order?.resellerPrice}
                                        </td>
                                        <td className="px-4 py-3 text-sm">{order?.location}</td>

                                        <td className="px-4 py-3 text-sm">
                                            {order?.phone}
                                        </td>
                                        <td className="px-4 py-3">
                                            <div className="flex items-center space-x-4 text-sm">
                                                <label
                                                    className="flex items-center justify-between py-2 text-sm font-medium leading-5 text-blue-700 rounded-lg dark:text-gray-400 dark:hover:text-white hover:text-blue-900 focus:outline-none focus:shadow-outline-gray btn btn-ghost btn-sm"
                                                    aria-label="Delete"
                                                    htmlFor="confirmation-modal"
                                                    title="Delete This Product From Wishlist"
                                                    onClick={() => setDeletingProduct(order)}
                                                >
                                                    <HiTrash className="w-5 h-5" />
                                                </label>
                                                <label
                                                    className="btn btn-primary btn-sm"
                                                    htmlFor="booking-modal"
                                                    onClick={() => setBooking(order)}
                                                    title="Book Now"
                                                    // disabled={bookLoading}
                                                >
                                                    {/* <div className="flex items-center gap-2 ">
                                                        {bookLoading ? (
                                                            <Spinner size="sm" light={true} />
                                                        ) : (
                                                            <HiOutlineBookmark className="h-5 w-5" />
                                                        )}
                                                        
                                                    </div> */}
                                                    <span>Book Now</span>
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                {booking && <BookingModal booking={booking} setBooking={setBooking} />}
                </div>
                {deletingProduct && (
                    <ConfirmationModal
                        title={`Are you sure you want to delete?`}
                        message={`If you delete ${deletingProduct.title}. It cannot be undone.`}
                        successAction={handleDeleteWishlist}
                        successButtonName="Delete"
                        modalData={deletingProduct}
                        closeModal={closeModal}></ConfirmationModal>
                )}
            </div>
        </>
    );
};

export default MyWishlist;